import React from 'react';
import { createPortal } from 'react-dom';
import styles from './LikersModal.module.css';
import { LikersModalProps } from './types';
import { toRelativePath } from '../../utils/videoImagePath';
import useLikersModal from './useLikersModal';

/**
 * いいねした人一覧を表示するモーダルコンポーネント
 */
const LikersModal: React.FC<LikersModalProps> = ({ title, likers, onClose }) => {
  const { handleClose } = useLikersModal();

  const modalContent = (
    <div className={styles['likers-modal-overlay']} data-testid="likers-modal">
      <div className={styles['likers-modal-content']}>
        <h4 className={styles['likers-modal-title']}>{title}</h4>
        {likers && likers.length > 0 ? (
          <ul className={styles['likers-modal-list']}>
            {likers.map((user) => (
              <li key={user.id} className={styles['likers-modal-list-item']} data-testid="likers-modal-list-item">
                <img
                  src={
                    user.icon_path
                      ? toRelativePath(user.icon_path)
                      : '/asset/no_icon_user.png'
                  }
                  alt="ユーザーアイコン"
                  className={styles['likers-modal-avatar']}
                />
                <span className={styles['likers-modal-name']}>
                  {user.name || '名無し'}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles['likers-modal-empty-message']}>いいねした人はいません</p>
        )}
        <button 
          onClick={() => handleClose(onClose)} 
          className={styles['likers-modal-close-button']}
          data-testid="likers-modal-close-button"
        >
          閉じる
        </button>
      </div>
    </div>
  );

  // body直下にPortalとしてレンダリング
  return createPortal(modalContent, document.body);
};

export default LikersModal; 